export default "__VITE_PUBLIC_ASSET__415c52c9__"